import {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../contexts/Auth/AuthContext";

export const MenuLeft = () => {
  const auth = useContext(AuthContext);
  const [isFullscreen, setIsFullscreen] = useState(false);

  function exitHandler()
  {
    if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement)
    {
      setIsFullscreen(false)
    }
  }

  useEffect(() => {
    if (document.addEventListener)
    {
      document.addEventListener('fullscreenchange', exitHandler, false);
      document.addEventListener('mozfullscreenchange', exitHandler, false);
      document.addEventListener('MSFullscreenChange', exitHandler, false);
      document.addEventListener('webkitfullscreenchange', exitHandler, false);
    }
  }, []);
  function toggleFullScreen() {
    if (!document.fullscreenElement &&    // Padrão W3C
        !document.mozFullScreenElement && // Firefox
        !document.webkitFullscreenElement && // Chrome, Safari e Opera
        !document.msFullscreenElement) {   // Internet Explorer/Edge
      // Entrar em tela cheia
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) { // Firefox
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari e Opera
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
        document.documentElement.msRequestFullscreen();
      }
      setIsFullscreen(true)
    } else {
      // Sair de tela cheia
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { // Chrome, Safari e Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen();
      }
      setIsFullscreen(false)
    }
  }


  const handleLogout = () => {
    return auth.signout();
  };
  return (
      <>{!isFullscreen &&
    <div className="menu" style={{flex:1, position: 'relative', paddingTop: 0}}>
      <div className="main-menu">
        <div className="scroll">
          <ul className="list-unstyled">
            <li className="">
              <a onClick={toggleFullScreen} href="#">
                <i className="simple-icon-size-fullscreen"></i> Fullscreen
              </a>
            </li>
            <li>
              <a href="/called">
                <i className="iconsminds-digital-drawing"></i> Painel
              </a>
            </li>
            <li className="">
              <a href="/practitioner">
                <i className="simple-icon-people"></i> Médicos
              </a>
            </li>
            <li className="">
              <a  onClick={handleLogout} href="#">
                <i className="simple-icon-logout"></i> Sair
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>}</>
  );
};
